/*TODO: setup sections? */

// var sections = window.theme.sections;
//
// var slideshowAutoExtension = {
//   init: function() {
//     this.on('slideshow_desktop_init_done', this._autoplaySlideshow.bind(this));
//   },
//   _autoplaySlideshow: setInterval(function() {
//     var $slide = $('.slideshow__slide--active')
//         .removeClass('slideshow__slide--active');
//
//     var $button = $('.slideshow__button--active')
//         .removeClass('slideshow__button--active');
//
//     var $slides = $('.slideshow__slide');
//
//     var currentIndex = ($slides.index($slide) + 1) % $slides.length;
//
//     $slides
//         .eq(currentIndex)
//         .addClass('slideshow__slide--active');
//
//     var $buttons = $('.slideshow__button')
//         .eq(currentIndex)
//         .addClass('slideshow__button--active');
//
//   }, 10000)
//
// };
//
// sections.extend('slideshow', slideshowAutoExtension);

/* GUI Helper */


var gui_helper_touch_x;
var gui_helper_touch_y;

var gui = {

  isEqual: function(a, b){
    if(a != undefined && b != undefined){
      if($(a)[0] == $(b)[0]){
        return true;
      }
    }

    return false;
  },

  goToStep_impl: function(element, type, target){
    var container  = $(element).closest(".step-container");
    var currentNode = $(element).closest(".step-node");
    var targetIndex;

    $(".step-node", $(container)).removeClass("active");


    var dis = this;

    switch(type){
      case 1: //next
        $(".step-node", $(container)).each(function(){
          if(dis.isEqual($(currentNode),$(this))){
            var elementIndex = $(currentNode).index();
            if(elementIndex < $(".step-node", $(container)).length -1){
              targetIndex = elementIndex + 1;
            }
            else{
              targetIndex = elementIndex;
            }
          }
        });
        break;
      case -1: //next
        $(".step-node", $(container)).each(function(){
          if(dis.isEqual($(currentNode),$(this))){
            var elementIndex = $(currentNode).index();
            if(elementIndex > 0){
              targetIndex = elementIndex -1;
            }
            else{
              targetIndex = elementIndex;
            }
          }
        });
        break;
      case 99:
        targetIndex = target;
        break;

    }


    $($(".step-node", $(container)).get(targetIndex)).addClass("active");
    window.dispatchEvent(new Event('resize'));
  },

  goToStep_impl_bySelector: function(selector, target){
    var container  = $(selector);
    $(".step-node", $(container)).removeClass("active");
    $($(".step-node", $(container)).get(target)).addClass("active");
    window.dispatchEvent(new Event('resize'));
  },

  goToStep_next : function(element) {
    var that = this;
    that.goToStep_impl(element, 1);
  },

  goToStep_prev : function(element) {
    var that = this;
    that.goToStep_impl(element, -1);
  },
  goToStep_index : function(element, index) {
    var that = this;
    that.goToStep_impl(element, 99, index);
  },

  goToStep2_impl: function(element, type, target){
    var container  = $(element).closest(".step-container-2");
    var currentNode = $(element).closest(".step-node-2");
    var targetIndex;

    $(".step-node-2", $(container)).removeClass("active");

    var dis = this;

    switch(type){
      case 1: //next
        $(".step-node-2", $(container)).each(function(){
          if(dis.isEqual($(currentNode),$(this))){
            var elementIndex = $(currentNode).index();
            if(elementIndex < $(".step-node-2", $(container)).length -1){
              targetIndex = elementIndex + 1;
            }
            else{
              targetIndex = elementIndex;
            }
          }
        });
        break;
      case -1: //next
        $(".step-node-2", $(container)).each(function(){
          if(dis.isEqual($(currentNode),$(this))){
            var elementIndex = $(currentNode).index();
            if(elementIndex > 0){
              targetIndex = elementIndex -1;
            }
            else{
              targetIndex = elementIndex;
            }
          }
        });
        break;
      case 99:
        targetIndex = target;
        break;

    }


    $($(".step-node-2", $(container)).get(targetIndex)).addClass("active");

  },

  init_stepContainer : function(stepContainer){
    if(!$(stepContainer).hasClass("evented")){
      $("<div class='step-next-btn-singleton'></div>").appendTo(stepContainer);
      $("<div class='step-prev-btn-singleton'></div>").appendTo(stepContainer);



      $(stepContainer)[0].addEventListener('touchstart', function(e){
        gui_helper_touch_x = e.changedTouches[0].screenX;
        gui_helper_touch_y = e.changedTouches[0].screenY;
      });
      $(stepContainer)[0].addEventListener('touchend', function(e){
        var touch_x_end = e.changedTouches[0].screenX;
        var touch_y_end = e.changedTouches[0].screenY;
        var touchDirection = gui.getTouchResult(touch_x_end, touch_y_end);
        if(touchDirection == 'left'){
          gui.stepImplement_singleton_next(stepContainer);
        }
        if(touchDirection == 'right'){
          gui.stepImplement_singleton_prev(stepContainer);
        }
      });

      $(".step-next-btn-singleton", $(stepContainer)).on('click', function(){
        gui.stepImplement_singleton_next(stepContainer);
      });
      $(".step-prev-btn-singleton", $(stepContainer)).on('click', function(){
        gui.stepImplement_singleton_prev(stepContainer);
      });

    }

    $(".step-node", $(stepContainer)).removeClass("active");
    $($(".step-node", $(stepContainer)).get(0)).addClass("active");
    $($(".step-node", $(stepContainer)).get(0)).addClass("appeared-anim");
    SHEEP_EVENTS.fire('step_container_change', {el: $(stepContainer), activeIndex : 0});

    // $('.step-prev-btn-singleton', $(stepContainer)).css("display", "none");
    // $('.step-next-btn-singleton', $(stepContainer)).css("display", "block");
    $(stepContainer).addClass("evented");
    var pagerVal = gui.getPagerValue($(stepContainer));
    $(".popupPager").html(pagerVal);

  },

  remove_loader(element){
    if($(element).hasClass("has-loader")){
      $(element).removeClass('has-loader');
    }else{
      var loader = $(element).closest('.has-loader-container');
      $(loader).removeClass('has-loader-container');

    }
  },

  add_loader(element){
    $(element).addClass('has-loader');
  },

  goToStep2_next : function(element) {
    var that = this;
    that.goToStep2_impl(element, 1);
  },

  goToStep2_prev : function(element) {
    var that = this;
    that.goToStep2_impl(element, -1);
  },
  goToStep2_index : function(element, index) {
    var that = this;
    that.goToStep2_impl(element, 99, index);
  },

  getTouchResult: function(touch_x_end, touch_y_end){

    var vh = parseInt($(window).width() / 100);


    if(Math.abs(touch_x_end - gui_helper_touch_x) < 4 * vh){
      return '';
    }


    if(touch_x_end < gui_helper_touch_x){
      return 'left';
    }
    if(touch_x_end > gui_helper_touch_x){
      return 'right';
    }
    if(touch_y_end < gui_helper_touch_y){
      return 'up';
    }
    if(touch_y_end > gui_helper_touch_y){
      return 'down';
    }
  },

  stepImplement_singleton_next: function(stepContainer){
    var activeIndex = 0;
    $(".step-node", $(stepContainer)).each(function(){
      if($(this).hasClass("active")){
        return false;
      }
      activeIndex++;
    });
    var totalSteps = $(".step-node", $(stepContainer)).length;
    console.log(activeIndex + " / " + totalSteps);
    if(activeIndex == (totalSteps - 1)){
      $(".step-node", $(stepContainer)).removeClass("active");
      $($(".step-node", $(stepContainer)).get(0)).addClass("active");
      SHEEP_EVENTS.fire('step_container_change', {el: $(stepContainer), activeIndex : 0});
      return false;
    }
    // else if(activeIndex == (totalSteps - 2)){
    //     $('.step-next-btn-singleton', $(stepContainer)).css("display", "none");
    // }
    $(".step-node", $(stepContainer)).removeClass("active");
    console.log(activeIndex+1);
    $($(".step-node", $(stepContainer)).get(activeIndex+1)).addClass("active");
    // $('.step-prev-btn-singleton', $(stepContainer)).css("display", "block");
    SHEEP_EVENTS.fire('step_container_change', {el: $(stepContainer), activeIndex : activeIndex+1});


  },

  stepImplement_singleton_prev: function(stepContainer){
    var activeIndex = 0;
    var totalSteps = $(".step-node", $(stepContainer)).length;
    $(".step-node", $(stepContainer)).each(function(){
      if($(this).hasClass("active")){
        return false;
      }
      activeIndex++;
    });
    if(activeIndex == 0){
      $(".step-node", $(stepContainer)).removeClass("active");
      $($(".step-node", $(stepContainer)).get(totalSteps-1)).addClass("active");
      SHEEP_EVENTS.fire('step_container_change', {el: $(stepContainer), activeIndex : totalSteps-1});
      return false;
    }
    // else if(activeIndex == 1){
    //     $(".step-prev-btn-singleton", $(stepContainer)).css("display", "none");
    // }
    $(".step-node", $(stepContainer)).removeClass("active");
    $($(".step-node", $(stepContainer)).get(activeIndex-1)).addClass("active");
    // $('.step-next-btn-singleton', $(stepContainer)).css("display", "block");
    SHEEP_EVENTS.fire('step_container_change', {el: $(stepContainer), activeIndex : activeIndex-1});

  },

  getPagerValue: function(el, delim){
    var container;
    if($(el).hasClass("step-container")){
      container = $(el);
    }
    else{
      container = $(el).closest(".step-container");
    }
    var active = 0;
    var totalCount = $(".step-node", $(container)).length;
    var counter = 1;
    $(".step-node", $(container)).each(function(){
      if($(this).hasClass("active")){
        active = counter;
        return false;
      }
      counter++;
    });

    if(delim){
      return  (active + delim + totalCount)
    }

    return (active + '—' + totalCount);

  },

  selectOne_select : function(element){
    var container = $(element).closest(".select-one-container");
    var node = $(element).closest(".select-node");
    $(".select-node", $(container)).removeClass("active");
    $(node).addClass("active");

    var value = $(node).attr("data-val");
    $(container).attr("data-val", value);
  },
  selectOne_select : function(element, callback){
    var container = $(element).closest(".select-one-container");
    var node = $(element).closest(".select-node");
    $(".select-node", $(container)).removeClass("active");
    $(node).addClass("active");

    var value = $(node).attr("data-val");
    $(container).attr("data-val", value);
    callback();
  },

  create_select:function(target, array){
    var innerHTML = '';
    for(var i in array){
      innerHTML += '<option value="'+ array[i].val +'">' +  array[i].text + '</option>';
    }
    $(target).html(innerHTML);


  },
  create_select:function(target, array, dataKey){
    var innerHTML = '';
    for(var i in array){
      innerHTML += '<option value="'+ array[i].val +'" data-'+dataKey+ ' = "' + array[i][dataKey] + '">' +  array[i].text + '</option>';
    }
    $(target).html(innerHTML);
  },
  create_select_keys:function(target, array){
    var innerHTML = '';
    for(var i in array){
      innerHTML += '<option value="'+ i +'">' +  array[i].text + '</option>';
    }
    $(target).html(innerHTML);
  },
  create_select_keys:function(target, array, callback){
    var deferred = jQuery.Deferred();
    var innerHTML = '';
    for(var i in array){
      innerHTML += '<option value="'+ i +'">' +  array[i].text + '</option>';
    }
    $(target).html(innerHTML);

    if(!$(target).hasClass("evented")){
      $(target).change(function(){callback($(this).val());});
    }

    $(target).addClass("evented");
    deferred.resolve();
    return deferred.promise();
  },

  close_popup : function(element){
    $(element).closest(".sgpb-popup-dialog-main-div-wrapper").css("display", "none");
    $(".sgpb-theme-1-overlay").click();
  },

  nullCheck : function(val){
    if(val == undefined) return false;
    if(val == '') return false;

    return true;
  },
  nullCheck_element : function(selector){
    if($(selector).val() == undefined) return false;
    if($(selector).val() == '') return false;

    return true;
  },

  email_check: function(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },
  email_check_element: function(email) {
    var val = $(email).val();
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(val).toLowerCase());
  },

  open_modal(selector){
    $(selector).css("display", "block");
    var rect = $(selector)[0].getBoundingClientRect();
    var height = parseInt(rect.height / 2);
    var width = parseInt(rect.width / 2);;

    $(selector).css("left", "calc(50vw - "+ width + "px)");
    $(selector).css("top", "calc(50vh - "+ height + "px)");
    $(selector).addClass("active");

  },

  open_modal_with_css(selector, css){
    $(selector).css("display", "block");
    $(selector).css(css);
    $(selector).addClass("active");
  },

  close_modal(selector){
    $(selector).removeClass("active");
    $(selector).css("left", "-100vw)");
    setTimeout(function(){
      $(selector).css("display", "none");
    }, 300);
  },
  scrollToTop : function(scrollDuration) {
    var scrollStep = -window.scrollY / (scrollDuration / 15),
        scrollInterval = setInterval(function(){
          if ( window.scrollY != 0 ) {
            window.scrollBy( 0, scrollStep );
          }
          else clearInterval(scrollInterval);
        },15);
  },

  setFloatingText: function(selector, direction, period){


    var isMobile = mobilecheck();

    var vw = $(window).width() / 100;
    var window_height = $(window).height();
    var vh = $(window).height() / 100;

    $(selector).each(function(){
      var container = $(this);
      if(isMobile){
        if(direction == 'left' || direction == undefined){

          $(container).children("h1").each(function(){
            var left = 0;
            for(i = 0; i < $(this).index(); i++){
              left += ($(container).children("h1").get(i).getBoundingClientRect().width + 5*vw);
            }
            left = parseInt(left);
            $(this).css("left", left + 'px');
          });

        }



      }
      else{
        if(direction == 'up'){
          $(container).children("h1").each(function(){
            var top = 0;
            for(i = 0; i < $(this).index(); i++){
              top += $(container).children("h1").get(i).getBoundingClientRect().height;
            }
            top = parseInt(top);
            $(this).css("top", top + 'px');
          });

        }
        if(direction == 'down'){
          $(container).children("h1").each(function(){
            var top = window_height;
            var element_width = $(this)[0].getBoundingClientRect().width;
            for(i = 0; i < $(this).index(); i++){
              top -= ($(container).children("h1").get(i).getBoundingClientRect().height + element_width);
            }
            top = parseInt(top);
            $(this).css("top", top + 'px');
          });

        }
      }
    });

    switch(direction){
      case 'left':
        setInterval(gui.animateScrollingText_left, period, selector, vw);
        break;
      case 'up':
        // setInterval(gui.animateScrollingText_up, period, selector, vh);
        break;
      case 'down':
        setInterval(gui.animateScrollingText_down, period, selector, vh, window_height);
        break;
    }



  },

  animateScrollingText_left: function(selector, vw){

    $(selector).each(function(){
      var container = $(this);
      $(container).children("h1").each(function(){
        var left = parseInt($(this).css("left"));
        left = left-1;
        $(this).css("left", left + 'px');

        var rightPos = $(this)[0].getBoundingClientRect().right;
        if(rightPos < 0){

          var prevElement;
          if($(this).index() == 0){
            prevElement = $(container).children("h1").get($(container).children("h1").length - 1);
          }
          else{
            prevElement = $(container).children("h1").get($(this).index()-1);
          }
          var prevElementWidth = $(prevElement)[0].getBoundingClientRect().width;
          var prevElementLeft = parseInt($(prevElement).css("left"));

          var newLeft  = parseInt(prevElementWidth + prevElementLeft + 5*vw);

          $(this).css("left" , newLeft + 'px');

        }
      });
    });
  },
  animateScrollingText_up: function(selector, vh){


    $(selector).each(function(){
      var container = $(this);
      $(container).children("h1").each(function(){
        var top = parseInt($(this).css("top"));
        top = top42;
        $(this).css("top", top + 'px');

        var bottomPos = $(this)[0].getBoundingClientRect().bottom;
        if(bottomPos < 0){

          var prevElement;
          if($(this).index() == 0){
            prevElement = $(container).children("h1").get($(container).children("h1").length - 1);
          }
          else{
            prevElement = $(container).children("h1").get($(this).index()-1);
          }
          var prevElementHeight = $(prevElement)[0].getBoundingClientRect().height;
          var prevElementtop = parseInt($(prevElement).css("top"));


          var newtop  = parseInt(prevElementHeight + prevElementtop);

          if($(this).index() == 0){
            var width = $(this)[0].getBoundingClientRect().width;
            newtop = newtop + $(container).children("h1").length * width;
          }


          $(this).css("top" , newtop + 'px');
        }

      });
    });
  },
  animateScrollingText_down: function(selector, vh, window_height){


    $(selector).each(function(){
      var container = $(this);
      $(container).children("h1").each(function(){
        var top = parseInt($(this).css("top"));
        top = top+2;
        $(this).css("top", top + 'px');

        var topPos = $(this)[0].getBoundingClientRect().top;
        if(topPos > window_height){

          var prevElement;
          if($(this).index() == 0){
            prevElement = $(container).children("h1").get($(container).children("h1").length - 1);
          }
          else{
            prevElement = $(container).children("h1").get($(this).index()-1);
          }
          var prevElementHeight = $(prevElement)[0].getBoundingClientRect().height;
          var prevElementtop = parseInt($(prevElement).css("top"));


          var newtop  = parseInt(prevElementtop - prevElementHeight );

          var width = $(this)[0].getBoundingClientRect().width;
          if($(this).index() == 0){
            newtop = newtop + $(container).children("h1").length * width;
          }
          newtop -= width;


          $(this).css("top" , newtop + 'px');
        }

      });
    });
  }




};

$(document).ready(function(){
  $(".select-node:not(.manual) .the-node").click(function(){
    gui.selectOne_select($(this));
  })

  $(".step-node .step-next-btn:not(.manual)").click(function(){
    gui.goToStep_next($(this));
  })

  $('.genderPickNextButton').click(function(){
    var val = $('#gender_selector').attr("data-val");
    if(val){
      gui.goToStep_next($(this));
    }else{
      $('#pickGenderWarning').show();
    }
  });

  $(".step-container-2 .step-trigger").click(function(){
    var target = $(this).attr("data-target");
    var container = $(this).closest(".step-container-2");
    gui.goToStep2_index($(this), target);
    $(".step-trigger", $(container)).removeClass("active");
    $(this).addClass("active");
  });
});


(function($){
  $.fn.extend({
    svgMarquee: function(options) {

      var defaults = {
        duplicate: true,
        cloneCount: 15
      };

      var options = $.extend(defaults, options);

      return this.each(function() {
        var o = options;
        var obj = $(this);
        var mText = obj.find('.marqueeText');
        var mTexts = [];
        var mTextLefts = [];
        var mTextWidth = mText[0].getBBox().width;
        var svgWidth = obj[0].getBBox().width;

        mTexts.push(mText);
        mTextLefts.push(svgWidth);
        mText.attr('startOffset', svgWidth);

        for(var i = 0; i < o.cloneCount; i++) {
          var dmText = mText.clone();
          dmText.appendTo(mText.parent());
          mTexts.push(dmText);
          var textLeft = svgWidth + ((i+1)*mTextWidth);
          dmText.attr('startOffset', textLeft);
          mTextLefts.push(textLeft);
        }

        mText.parent().css('opacity', 1);

        setInterval(function() {
          for(var i = 0; i < mTexts.length; i++) {
            var left = mTextLefts[i];
            left--;
            if(left < -mTextWidth) {
              var prevIndex = i == 0 ? mTexts.length - 1 : i - 1;
              var prevLeft = mTextLefts[prevIndex];
              left = prevLeft - 1 + mTextWidth;
            }
            mTexts[i].attr('startOffset', left);
            mTextLefts[i] = left;
          }
        }, 10);

      });
    }
  });
})(jQuery);


function setWithExpiry(key, value, ttl) {
  const now = new Date()

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  }
  localStorage.setItem(key, JSON.stringify(item))
}

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key)
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null
  }
  const item = JSON.parse(itemStr)
  const now = new Date()
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key)
    return null
  }
  return item.value
}

//Drawer Test
var drawerTest = getWithExpiry("drawerTest") == null ? false : getWithExpiry("drawerTest");
if(!drawerTest && window.location.href.includes("drawerTest=true")) {
  //set test value with 1 week ttl
  drawerTest = true
  setWithExpiry("drawerTest", drawerTest, 1000*60*60*24*7);
}

$(function() {
  if(drawerTest) {
    $('.drawerBeanie').remove();
  }
});

var randomProperty = function (obj) {
  var keys = Object.keys(obj);
  return obj[keys[ keys.length * Math.random() << 0]];
};


const UUIDv4 = new function() {
  const generateNumber = (limit) => {
    const value = limit * Math.random();
    return value | 0;
  };
  const generateX = () => {
    const value = generateNumber(16);
    return value.toString(16);
  };
  const generateXes = (count) => {
    let result = '';
    for(let i = 0; i < count; ++i) {
      result += generateX();
    }
    return result;
  };
  const generateVariant = () => {
    const value = generateNumber(16);
    const variant = (value & 0x3) | 0x8;
    return variant.toString(16);
  };
  // UUID v4
  //
  //   varsion: M=4
  //   variant: N
  //   pattern: xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
  //
  this.generate = function() {
    const result = generateXes(8)
        + '-' + generateXes(4)
        + '-' + '4' + generateXes(3)
        + '-' + generateVariant() + generateXes(3)
        + '-' + generateXes(12)
    return result;
  };
};